import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

export default class SwappableRateConfig extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, eventId, rateId }) {
        if (!organizationId || !eventId || !rateId) {
            throw new ArgumentError(`[Model][SwappableRateConfig] organizationId, eventId and rateId are mandatory`);
        }
        return `/ticket/organizations/${organizationId}/events/${eventId}/rates/${rateId}/swapable_rate_configs`;
    }

    static perform_delete(data, { organizationId, eventId, rateId }) {
        return fetcher.post(`/ticket/organizations/${organizationId}/events/${eventId}/rates/${rateId}/swapable_rate_configs/bulk_delete`, { data: { ids: data } });
    }
}
